import quickFetch from 'quick-fetch';
import http from 'hub-http/clients/apiClient';
import { logError } from '../utils/errorHandling';
export const fetchCurrencyInfo = () => {
  const fetch = () => http.get('multi-currency/v2/currencies/information');

  const earlyRequest = quickFetch.getRequestStateByName('currency');

  if (earlyRequest) {
    return new Promise((resolve, reject) => {
      earlyRequest.whenFinished(request => {
        resolve(request);
        quickFetch.removeEarlyRequest('currency');
      });
      earlyRequest.onError(() => {
        fetch().then(resolve, reject).catch(logError);
        quickFetch.removeEarlyRequest('currency');
      });
    });
  }

  return fetch().then(response => response);
};